import { Box, Button, Typography } from '@mui/material';

interface VenueLoadErrorProps {
  onRetry: () => void;
}

export function VenueLoadError({ onRetry }: VenueLoadErrorProps) {
  return (
    <Box
      sx={{
        p: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        minHeight: '50vh',
        justifyContent: 'center',
      }}
    >
      <Typography variant="h6">Could not load your venues</Typography>
      <Typography variant="body2" color="text.secondary">
        Please check your connection and try again.
      </Typography>
      <Button variant="contained" onClick={onRetry}>
        Try again
      </Button>
    </Box>
  );
}
